import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../../data/fields';
import MultiSelect from '../multi-select/MultiSelect';
import ClientsAction from '../../app/store/actions/clients';
import { createNotify, updateNotify } from '../../app/store/actions/notify';
import SelectComponent from '../select/Select';

class NotifyFormComponent extends Component {
  constructor(props) {
    super(props);
    const UrlApp = [
      { name: I18n.t('screenHome'), value: 'ACTION_OPEN_HOME' },
      { name: I18n.t('screenProduct'), value: 'ACTION_OPEN_PRODUCTS' },
      { name: I18n.t('screenCart'), value: 'ACTION_OPEN_CART' },
    ];
    this.state = {
      id: null,
      editNotify: false,
      isLoading: false,
      title: '',
      listClient: [],
      checked: [],
      allClient: false,
      description: '',
      buttonName: '',
      urlInternal: '',
      parametersUrl: '',
      urlExternal: '',
      messageErro: '',
      messageSuccess: '',
      UrlApp,
    };
  }

  setValue = (att, value) => {
    if (value && value < 0) {
      this.setState({ [att]: Math.abs(value) });
    } else {
      this.setState({ [att]: value });
    }
  }

  selectAllCustomers = async () => {
    await this.setState({
      allClient: true,
      checked: [...[]],
    })
  }

  clearSelectedCustomers = async () => {
    this.setState({ allClient: false })
    this.setState({ checked: [...[]] })
  } 

  goBack = () => {
    this.props.back.goBack();
  };


  formatUrlParameters = (parametersUrl, urlInternal) => {
    const result = parametersUrl.split('?');
    const paramString = (result.length === 2) ? result[1].split('&') : result[0].split('&');

    const queryParams = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const query of paramString) {
      const [key, value] = query.split('=');
      queryParams[key] = decodeURIComponent(value);
    }
    return JSON.stringify({ urlInternal, ...queryParams });
  }

  createNotify = async () => {
    this.setState({ isLoading: true });
    const {
      title, description, checked, allClient, urlInternal, urlExternal, buttonName,
      parametersUrl,
    } = this.state;
    let newUrlInternal = JSON.stringify({ urlInternal });

    if (parametersUrl) newUrlInternal = this.formatUrlParameters(parametersUrl, urlInternal);

    if(!title || !description || (checked.length === 0 && !allClient)){
      this.setState({ messageErro: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return
    }

    try {
      await this.props.createNotify({
        title, description, clients: checked, allClient, urlInternal: newUrlInternal, urlExternal, buttonName,
      });

      await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })

      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageErro: messageError })
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  setSelectedNotify = async (selectedNotify) => {
    const checked = [];
    let urlInternal = '';
    let parametersUrl = '';
    const allClient = selectedNotify.isAllClient;

    if (!allClient) {
      // eslint-disable-next-line no-restricted-syntax
      for (const client of selectedNotify.notifyUserClient) {
        if (checked.indexOf(String(client.clientId)) === -1) {
          checked.push(String(client.clientId));
        }
      }
    }

    if (selectedNotify.urlInternal) {
      const result = JSON.parse(selectedNotify.urlInternal);
      urlInternal = result.urlInternal;
      delete result.urlInternal;
      parametersUrl = (Object.keys(result).length)
        ? Object.entries(result).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')
        : '';
    }

    this.setState({
      editNotify: true,
      id: selectedNotify.id,
      title: selectedNotify.title,
      checked: !allClient ? checked : [],
      allClient: selectedNotify.isAllClient,
      buttonName: (selectedNotify.buttonName) ? selectedNotify.buttonName : '',
      description: selectedNotify.description,
      urlExternal: selectedNotify.urlExternal,
      urlInternal,
      parametersUrl,
    });
  }

  updateNotify = async () => {
    this.setState({ isLoading: true });
    const {
      id, title, description, checked, allClient, urlInternal, urlExternal, buttonName,
      parametersUrl,
    } = this.state;
    let newUrlInternal = JSON.stringify({ urlInternal });

    if(!id || !title || !description || (checked.length === 0 && !allClient)){
      this.setState({ messageErro: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return
    }

    if (parametersUrl) newUrlInternal = this.formatUrlParameters(parametersUrl, urlInternal);

    try {
      await this.props.updateNotify(
        {
          id, title, description, clients: checked, allClient, urlInternal: newUrlInternal, urlExternal, buttonName,
        },
      );

      await this.setState({ messageSuccess: I18n.t('changeMade') });
      await this.goBack();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      this.setState({ messageSuccess: '' })

      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageErro: messageError })
      } else {
        this.setState({ messageErro: I18n.t('errorOcurred') })
      }
    }
    this.setState({ isLoading: false });
  }

  componentDidMount = async () => {
    const listClient = await this.props.getAllClients();
    await this.setState({ listClient: [...listClient]});

    if (this.props.back.location.selectedNotify) {
      await this.setSelectedNotify(this.props.back.location.selectedNotify);
    }
  }

  render() {
    const {
      title, isLoading, messageSuccess, parametersUrl,
      listClient, description, messageErro, editNotify,
      urlInternal, urlExternal, buttonName, UrlApp,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {I18n.t('notificationRegistration')}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('title')}
            </p>
            <input
              type="text"
              onChange={e => this.setValue('title', `${e.target.value}`)}
              value={title}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('message')}
            </p>
            <input
              type="text"
              onChange={e => this.setValue('description', e.target.value)}
              value={description}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div>
            {
              <div
                className="row margin-left-0 margin-top-10"
                style={{ marginBottom: '5px' }}
              >
                <button
                  type="button"
                  style={{ height: '1%' }}
                  onClick={this.clearSelectedCustomers}
                  className="btn btn-dark btn-sm margin-right-15"                  
                >
                  {I18n.t('clean')}
                </button>

                <button
                  type="button"
                  style={{ height: '1%' }}
                  className="btn btn-dark btn-sm"
                  onClick={this.selectAllCustomers}
                >
                  {I18n.t('allCustomers')}
                </button>
              </div>
            }
            <div className="form-group">
              <p
                style={!this.state.allClient && !!listClient.length ? { marginBottom: '0px' } : {}}
                className={(this.state.allClient) ? "margin-bottom-2" : ''}
              >
                {I18n.t('clients')}
              </p>
              {!this.state.allClient && !!listClient.length ? (
                <MultiSelect
                  options={listClient}
                  checked={this.state.checked}
                  className="form-control multiSelect-input"
                />
              ) : (
                <input
                  type="text"
                  value={I18n.t('allSelectedCustomer')}
                  disabled={true}
                  className="form-control"
                  placeholder=""
                />
              )}
            </div>
            <div className="form-group">
              <p className="margin-bottom-2">
                {I18n.t('buttonName')}
              </p>
              <input
                type="text"
                onChange={e => this.setValue('buttonName', e.target.value)}
                value={buttonName}
                className="form-control"
                placeholder=""
                maxLength={FIELDS.button_name}
              />
            </div>
            <div className="form-group">              
              <SelectComponent
                title={I18n.t('urlToRedirectInternal')}
                value={urlInternal}
                body={UrlApp.map(val => (<option key={val.value} value={val.value}>{val.name}</option>))}
                onChange={(e) => {
                  this.setValue('urlInternal', `${e.target.value}`);
                  this.setValue('parametersUrl', '');
                }}
                disabled={!!urlExternal}
              />
            </div>
            {(urlInternal === 'ACTION_OPEN_PRODUCTS') && (
              <div className="form-group">
                <p className="margin-bottom-2">
                  {I18n.t('filterProducts')}
                </p>
                <input
                  type="text"
                  onChange={e => this.setValue('parametersUrl', `${e.target.value}`)}
                  value={parametersUrl}
                  className="form-control"
                />
              </div>
            )}
            <div className="form-group">
              <p className="margin-bottom-2">
                {I18n.t('urlToRedirectExternal')}
              </p>
              <input
                type="text"
                onChange={e => this.setValue('urlExternal', `${e.target.value}`)}
                value={urlExternal}
                className="form-control"
                placeholder="https://...."
                maxLength={FIELDS.max}
                disabled={!!urlInternal}
              />
            </div>
          </div>                  

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageErro && <p className="color-red margin-top-10">{messageErro}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => (!editNotify) ? this.createNotify() : this.updateNotify()}
              disabled={isLoading}
            >
              {(!editNotify) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllClients: () => dispatch(ClientsAction.getAllClients()),  
  createNotify: (newNotify) => dispatch(createNotify(newNotify)),
  updateNotify: (discountNotifyParameter) => dispatch(updateNotify(discountNotifyParameter)),
});

const mapStateToProps = state => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(NotifyFormComponent);
